import state from './moduleSupportState.js'
import mutations from './moduleSupportMutations.js'
import actions from './moduleSupportActions.js'
import getters from './moduleSupportGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
